import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
const guideRowHtml = (_props) => {
  return html`
    <div class="${EditorClasses.Row}">
      <div class="row row--gap-16">
        <ssg-children/>
      </div>
    </div>
  `;
};
export {
  guideRowHtml
};
//# sourceMappingURL=component.js.map
